"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-inputtool-emoji"
  }, [_c('div', {
    staticClass: "kiwi-inputtool-emoji-palette",
    on: {
      "mousedown": function ($event) {
        $event.preventDefault();
      },
      "click": function ($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l(_vm.emojis, function (text, eCode) {
    return _c('div', {
      key: eCode,
      staticClass: "kiwi-inputtool-emoji-emoji",
      style: {
        'background-image': `url(${_vm.location}${eCode})`
      },
      attrs: {
        "data-code": text
      },
      on: {
        "click": _vm.onImgClick
      }
    });
  }), 0)]);
};
var staticRenderFns = exports.staticRenderFns = [];